<template>
  <div>
    <div class="header">
      <div class="container-fluid">

        <b-row class="align-items-center mt-3 mb-2">
          <b-col>
            <span class="text-muted" v-if="solicitudesFiltradas.length !== solicitudes.length">
              {{ solicitudesFiltradas.length }} / {{ solicitudes.length }} {{ $t('resultado_solicitudes') }}
            </span>
            <span class="text-muted" v-else>{{ solicitudes.length }} {{ $t('resultado_solicitudes') }}</span>
          </b-col>
          <b-col class="text-right">
            <b-button variant="outline-secondary" size="sm" class="mr-2" @click="mostrarFiltros = !mostrarFiltros">
              <b-icon icon="funnel" class="mr-1" />
              {{ $t('filtros') }}
              <b-badge v-if="filtrosActivos > 0" variant="primary" class="ml-1">{{ filtrosActivos }}</b-badge>
            </b-button>
            <b-button variant="primary" size="sm" @click="cargarSolicitudes" :disabled="cargando">
              <b-spinner small v-if="cargando" class="mr-1" />
              {{ $t('refrescar') }}
            </b-button>
          </b-col>
        </b-row>

        <b-card v-if="mostrarFiltros" class="mb-3 shadow-sm">
          <b-row class="mb-2">
            <b-col md="3">
              <label class="form-label">{{ $t('tipo_solicitud') }}</label>
              <b-form-select v-model="filtros.idTipo" :options="opcionesTipoFiltro" />
            </b-col>
            <b-col md="2">
              <label class="form-label">{{ $t('estado') }}</label>
              <b-form-select v-model="filtros.estado" :options="opcionesEstadoFiltro" />
            </b-col>
            <b-col md="3">
              <label class="form-label">{{ $t('asignado_a') }}</label>
              <b-form-select v-model="filtros.idUsuarioKam" :options="opcionesKamFiltro" />
            </b-col>
            <b-col md="2">
              <label class="form-label">{{ $t('fecha_desde') }}</label>
              <b-form-input type="date" v-model="filtros.fechaDesde" />
            </b-col>
            <b-col md="2">
              <label class="form-label">{{ $t('fecha_hasta') }}</label>
              <b-form-input type="date" v-model="filtros.fechaHasta" />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <label class="form-label">{{ $t('nombre') }}</label>
              <b-form-input v-model="filtros.nombre" :placeholder="$t('nombre')" />
            </b-col>
            <b-col md="4">
              <label class="form-label">{{ $t('correo') }}</label>
              <b-form-input v-model="filtros.email" :placeholder="$t('correo')" />
            </b-col>
            <b-col class="d-flex align-items-end">
              <b-button variant="link" size="sm" @click="limpiarFiltros">{{ $t('limpiar_filtros') }}</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-alert variant="danger" :show="!!error" dismissible @dismissed="error = ''">
          {{ error }}
        </b-alert>

        <div v-if="cargando" class="text-center text-muted mt-5">
          <b-spinner variant="primary" />
        </div>

        <div v-else-if="solicitudes.length" class="card shadow">
          <div class="tabla-scroll-fixed" ref="tablaSolicitudes">
            <table class="table table-hover align-items-center mb-0">
              <thead class="thead-sticky thead-light">
                <tr>
                  <th class="th-ordenable" @click="ordenarPor('id')">
                    <input class="th-search-input" v-model="filterCol.id" @click.stop placeholder="Filtrar…" />
                    <span class="th-label">ID <i :class="iconoOrden('id')"></i></span>
                  </th>
                  <th>
                    <span class="th-label">{{ $t('tipo_solicitud') }}</span>
                  </th>
                  <th class="th-ordenable" @click="ordenarPor('fechaRegistro')">
                    <span class="th-label">{{ $t('fecha') }} <i :class="iconoOrden('fechaRegistro')"></i></span>
                  </th>
                  <th class="th-ordenable" style="min-width:140px;" @click="ordenarPor('nombre')">
                    <input class="th-search-input" v-model="filterCol.nombre" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('nombre') }} <i :class="iconoOrden('nombre')"></i></span>
                  </th>
                  <th class="th-ordenable" style="min-width:140px;" @click="ordenarPor('empresa')">
                    <input class="th-search-input" v-model="filterCol.empresa" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('empresa') }} <i :class="iconoOrden('empresa')"></i></span>
                  </th>
                  <th class="th-ordenable" style="min-width:160px;" @click="ordenarPor('email')">
                    <input class="th-search-input" v-model="filterCol.email" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('correo') }} <i :class="iconoOrden('email')"></i></span>
                  </th>
                  <th>
                    <span class="th-label">{{ $t('fono') }}</span>
                  </th>
                  <th class="th-ordenable text-center" @click="ordenarPor('cantidad')">
                    <span class="th-label">{{ $t('cantidad_label') }} <i :class="iconoOrden('cantidad')"></i></span>
                  </th>
                  <th style="min-width:180px;">
                    <span class="th-label">{{ $t('mensaje') }}</span>
                  </th>
                  <th class="th-ordenable text-center" @click="ordenarPor('estado')">
                    <input class="th-search-input" v-model="filterCol.estado" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('estado') }} <i :class="iconoOrden('estado')"></i></span>
                  </th>
                  <th>
                    <span class="th-label">{{ $t('asignado_a') }}</span>
                  </th>
                  <th style="width:120px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="s in solicitudesPaginadas" :key="s.id">
                  <td>{{ s.id }}</td>
                  <td>{{ labelTipo(s) }}</td>
                  <td>{{ formatFecha(s.fechaRegistro) }}</td>
                  <td>{{ s.nombre }}</td>
                  <td>{{ s.empresa || '-' }}</td>
                  <td>{{ s.email }}</td>
                  <td>{{ s.fono || '-' }}</td>
                  <td class="text-center">{{ s.cantidad || '-' }}</td>
                  <td>{{ s.mensaje ? (s.mensaje.length > 60 ? s.mensaje.substring(0, 60) + '…' : s.mensaje) : '-' }}</td>
                  <td class="text-center">
                    <span :class="badgeClass(s.estado)">{{ labelEstado(s.estado) }}</span>
                    <div v-if="s.estado === 'A' && s.fechaAsignacionKam" class="text-muted" style="font-size:0.75rem">{{ formatFecha(s.fechaAsignacionKam) }}</div>
                    <div v-if="s.estado === 'C' && s.fechaCierre" class="text-muted" style="font-size:0.75rem">{{ formatFecha(s.fechaCierre) }}</div>
                  </td>
                  <td>{{ nombreKam(s.idUsuarioKam) }}</td>
                  <td class="text-center">
                    <b-button size="sm" variant="outline-primary" @click="abrirDetalle(s)" class="mr-1">{{ $t('ver_detalle') }}</b-button>
                    <a v-if="s.mongoSlug" :href="`${ecommerceUrl}/product/${s.mongoSlug}`" target="_blank" :title="$t('ver_en_ecommerce')" class="btn btn-sm btn-outline-success">
                      🌐
                    </a>
                    <b-button v-if="puedeEscribir" size="sm" variant="outline-danger" class="ml-1"
                      :disabled="eliminandoId === s.id" @click="eliminarSolicitud(s)" :title="$t('eliminar')">
                      <b-spinner small v-if="eliminandoId === s.id" />
                      <i v-else class="fas fa-trash-alt"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Barra de paginación y scroll fija en el pie -->
        <div v-if="solicitudes.length" class="pagination-floating-bar">
          <div class="d-flex align-items-center">
            <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') || 'Items / pág.' }}</label>
            <select v-model.number="pageSize" @change="currentPage = 1" class="form-control form-control-sm" style="width:70px;">
              <option :value="20">20</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="200">200</option>
              <option :value="999999">Todas</option>
            </select>
          </div>
          <div class="d-flex align-items-center" style="gap:12px;">
            <button class="btn btn-outline-secondary btn-sm" :disabled="currentPage === 1" @click="currentPage--">
              <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') || 'Anterior' }}
            </button>
            <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
              {{ $t('pagina') || 'Página' }} {{ currentPage }} {{ $t('de') || 'de' }} {{ totalPages }}
              <span class="text-muted ml-2" style="font-size:.8rem;">({{ solicitudesFiltradas.length }} {{ $t('resultados') || 'resultados' }})</span>
            </span>
            <button class="btn btn-outline-primary btn-sm" :disabled="currentPage >= totalPages" @click="currentPage++">
              {{ $t('siguiente') || 'Siguiente' }} <i class="fas fa-arrow-right ml-1"></i>
            </button>
          </div>
          <div class="d-flex align-items-center" style="gap:6px;">
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('left')" title="Scroll izquierda"><i class="fas fa-chevron-left"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('right')" title="Scroll derecha"><i class="fas fa-chevron-right"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('top')" title="Ir al inicio"><i class="fas fa-chevron-up"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('bottom')" title="Ir al final"><i class="fas fa-chevron-down"></i></button>
          </div>
        </div>

        <div v-else-if="!cargando" class="text-center text-muted mt-5">
          <i class="fas fa-inbox fa-3x mb-3"></i>
          <p>{{ $t('sin_solicitudes') }}</p>
        </div>

      </div>
    </div>

    <b-modal v-model="modalVisible" :title="$t('detalle_solicitud')" size="lg" hide-footer>
      <div v-if="solicitudSeleccionada" class="detalle-modal">
        <div class="row">
          <div class="col-md-6">
            <div class="detalle-item">
              <span class="detalle-label">ID</span>
              <span class="detalle-valor">{{ solicitudSeleccionada.id }}</span>
            </div>
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('nombre') }}</span>
              <span class="detalle-valor">{{ solicitudSeleccionada.nombre }}</span>
            </div>
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('empresa') }}</span>
              <span class="detalle-valor">{{ solicitudSeleccionada.empresa || '-' }}</span>
            </div>
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('correo') }}</span>
              <span class="detalle-valor">{{ solicitudSeleccionada.email }}</span>
            </div>
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('fono') }}</span>
              <span class="detalle-valor">{{ solicitudSeleccionada.fono || '-' }}</span>
            </div>
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('fecha_registro') }}</span>
              <span class="detalle-valor">{{ formatFecha(solicitudSeleccionada.fechaRegistro) }}</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('cantidad_label') }}</span>
              <span class="detalle-valor">{{ solicitudSeleccionada.cantidad || '-' }}</span>
            </div>
            <div class="detalle-item">
              <span class="detalle-label">{{ $t('mensaje') }}</span>
              <span class="detalle-valor">{{ solicitudSeleccionada.mensaje || '-' }}</span>
            </div>
          </div>
        </div>

        <hr class="my-3" />

        <!-- ADJUNTOS -->
        <div class="mb-3" v-if="solicitudSeleccionada && solicitudSeleccionada.idTipo !== 'U'">
          <div class="detalle-label mb-2">📎 {{ $t('adjuntos') }}</div>
          <div v-if="cargandoAdjuntos" class="text-muted small">
            <b-spinner small class="mr-1" /> {{ $t('cargando') }}…
          </div>
          <div v-else-if="adjuntos.length === 0" class="text-muted small">
            {{ $t('sin_archivos_adjuntos') }}
          </div>
          <ul v-else class="list-unstyled mb-0">
            <li v-for="adj in adjuntos" :key="adj.id" class="adjunto-item">
              <a :href="adj.url" target="_blank" rel="noopener" class="adjunto-link">
                📄 {{ adj.archivo || $t('archivo') }}
              </a>
            </li>
          </ul>
        </div>

        <template v-if="solicitudSeleccionada.estado === 'A'">
        <hr class="my-3" />

        <!-- COTIZACIÓN -->
        <div class="mb-3" v-if="solicitudSeleccionada && solicitudSeleccionada.idTipo !== 'U'">
          <div class="detalle-label mb-2">📑 Cotización</div>
          <div v-if="cargandoCotizaciones" class="text-muted small">
            <b-spinner small class="mr-1" /> {{ $t('cargando') }}…
          </div>
          <div v-else>
            <ul v-if="cotizaciones.length" class="list-unstyled mb-2">
              <li v-for="cot in cotizaciones" :key="cot.id" class="adjunto-item d-flex align-items-center justify-content-between">
                <a :href="cot.url" target="_blank" rel="noopener" class="adjunto-link">
                  📑 {{ cot.archivo || 'Cotización' }}
                </a>
                <b-button v-if="puedeEscribir" size="sm" variant="outline-danger" class="ml-2 py-0 px-1" @click="eliminarCotizacion(cot.id)">
                  <i class="fas fa-trash-alt fa-xs" />
                </b-button>
              </li>
            </ul>
            <div class="cotizacion-upload" v-if="puedeEscribir">
              <label class="btn btn-outline-secondary btn-sm mb-0" style="cursor:pointer;">
                <b-spinner small v-if="subiendoCotizacion" class="mr-1" />
                <i v-else class="fas fa-paperclip mr-1" />
                Adjuntar cotización
                <input type="file" class="d-none" accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg" @change="subirCotizacion" :disabled="subiendoCotizacion" />
              </label>
              <small class="text-muted ml-2">PDF, imágenes o documentos</small>
            </div>
          </div>
        </div>
        </template>

        <hr class="my-3" />

        <div class="row">
          <div class="col-md-4">
            <label class="form-label">{{ $t('estado') }}</label>
            <b-form-select v-model="formEdicion.estado" :options="opcionesEstado" :disabled="!puedeEscribir" />
          </div>
          <div class="col-md-4">
            <label class="form-label">KAM</label>
            <b-form-select v-model="formEdicion.idUsuarioKam" :options="opcionesKam" :disabled="!puedeEscribir" />
          </div>
          <div class="col-md-4" v-if="solicitudSeleccionada && solicitudSeleccionada.fechaAsignacionKam">
            <label class="form-label">{{ $t('fecha_asignacion_kam') }}</label>
            <div class="form-control-plaintext text-muted small pt-2">
              {{ formatFecha(solicitudSeleccionada.fechaAsignacionKam) }}
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <label class="form-label">{{ $t('observacion_interna') }}</label>
            <b-form-textarea
              v-model="formEdicion.observacionInterna"
              rows="2"
              :disabled="!puedeEscribir"
              :placeholder="$t('agregar_observacion')"
            />
          </div>
        </div>

        <div class="text-right mt-3">
          <b-button variant="secondary" class="mr-2" @click="modalVisible = false">{{ $t('cancelar') }}</b-button>
          <b-button v-if="puedeEscribir" variant="primary" @click="guardarCambios" :disabled="guardando">
            <b-spinner small v-if="guardando" class="mr-1" />
            {{ $t('guardar') }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import peticionProductoService from '@/api/peticionProductoService';
import archivoAdjuntoService from '@/api/archivoAdjuntoService';
import userService from '@/api/userService';
import diccionarioService from '@/api/diccionarioService';
import Swal from 'sweetalert2';

export default {
  name: 'SolicitudesView',

  data() {
    return {
      solicitudes: [],
      eliminandoId: null,
      // Tipos de solicitud de dbo.Diccionarios (Tipo = 'SOL-ECOM')
      tiposSolicitud: [],
      cargando: false,
      error: '',
      ordenColumna: null,
      ordenDireccion: 'asc',
      modalVisible: false,
      solicitudSeleccionada: null,
      guardando: false,
      formEdicion: {
        estado: 'P',
        observacionInterna: '',
        idUsuarioKam: null,
      },
      adjuntos: [],
      cargandoAdjuntos: false,
      kamsOptions: [],
      cotizaciones: [],
      cargandoCotizaciones: false,
      subiendoCotizacion: false,
      mostrarFiltros: false,
      filtros: {
        idTipo: null,
        estado: null,
        idUsuarioKam: null,
        nombre: '',
        email: '',
        fechaDesde: '',
        fechaHasta: '',
      },
      filterCol: {
        id: '',
        nombre: '',
        empresa: '',
        email: '',
        estado: '',
      },
      currentPage: 1,
      pageSize: 50,
    };
  },

  watch: {
    filtros: { deep: true, handler() { this.currentPage = 1; } },
    filterCol: { deep: true, handler() { this.currentPage = 1; } },
  },

  mounted() {
    this.$store.dispatch('setSidebarCollapsed', false);
    this._scrollHandler = this._onWindowScrollSolicitudes.bind(this);
    window.addEventListener('scroll', this._scrollHandler, { passive: true });
    this.cargarSolicitudes();
    this.cargarKams();
    this.cargarTiposSolicitud();
  },

  beforeDestroy() {
    this.$store.dispatch('setSidebarCollapsed', false);
    window.removeEventListener('scroll', this._scrollHandler);
  },

  computed: {
    ecommerceUrl() {
      return (process.env.VUE_APP_ECOMMERCE_URL || 'https://ecommerce.inexlink.com').replace(/\/+$/, '');
    },
    opcionesEstado() {
      return [
        { value: 'P', text: this.$t('estado_por_asignar') },
        { value: 'A', text: this.$t('estado_asignado') },
        { value: 'C', text: this.$t('estado_cerrado') },
        { value: 'E', text: this.$t('estado_cerrado_sin_exito') },
      ];
    },
    filtrosActivos() {
      const f = this.filtros;
      return [f.idTipo, f.estado, f.idUsuarioKam, f.nombre, f.email, f.fechaDesde, f.fechaHasta]
        .filter(v => v !== null && v !== '').length;
    },
    // Se arma con dbo.Diccionarios (Tipo = 'SOL-ECOM') en lugar de una lista
    // fija: si se agrega un tipo de solicitud, aparece aquí sin tocar código.
    opcionesTipoFiltro() {
      const esIngles = this.$getLanguage() === 'en';
      const opciones = (this.tiposSolicitud || []).map(t => ({
        value: t.id,
        text: (esIngles && t.nombreIngles) ? t.nombreIngles : t.nombre,
      }));
      return [{ value: null, text: `— ${this.$t('todos')} —` }, ...opciones];
    },
    opcionesEstadoFiltro() {
      return [
        { value: null, text: `— ${this.$t('todos')} —` },
        { value: 'P', text: this.$t('estado_por_asignar') },
        { value: 'A', text: this.$t('estado_asignado') },
        { value: 'C', text: this.$t('estado_cerrado') },
        { value: 'E', text: this.$t('estado_cerrado_sin_exito') },
      ];
    },
    opcionesKamFiltro() {
      return [
        { value: null, text: `— ${this.$t('todos')} —` },
        ...this.kamsOptions.map(k => ({ value: k.value, text: k.text })),
      ];
    },
    solicitudesFiltradas() {
      const fc = this.filterCol;
      let lista = this.solicitudes;
      // Panel filters
      if (this.filtros.idTipo) lista = lista.filter(s => s.idTipo === this.filtros.idTipo);
      if (this.filtros.estado) lista = lista.filter(s => s.estado === this.filtros.estado);
      if (this.filtros.idUsuarioKam) lista = lista.filter(s => s.idUsuarioKam === this.filtros.idUsuarioKam);
      if (this.filtros.nombre) lista = lista.filter(s => s.nombre && s.nombre.toLowerCase().includes(this.filtros.nombre.toLowerCase()));
      if (this.filtros.email) lista = lista.filter(s => s.email && s.email.toLowerCase().includes(this.filtros.email.toLowerCase()));
      if (this.filtros.fechaDesde) lista = lista.filter(s => s.fechaRegistro && s.fechaRegistro >= this.filtros.fechaDesde);
      if (this.filtros.fechaHasta) lista = lista.filter(s => s.fechaRegistro && s.fechaRegistro <= this.filtros.fechaHasta + 'T23:59:59');
      // Column filters
      if (fc.id)      lista = lista.filter(s => String(s.id || '').toLowerCase().includes(fc.id.toLowerCase()));
      if (fc.nombre)  lista = lista.filter(s => (s.nombre || '').toLowerCase().includes(fc.nombre.toLowerCase()));
      if (fc.empresa) lista = lista.filter(s => (s.empresa || '').toLowerCase().includes(fc.empresa.toLowerCase()));
      if (fc.email)   lista = lista.filter(s => (s.email || '').toLowerCase().includes(fc.email.toLowerCase()));
      if (fc.estado)  lista = lista.filter(s => this.labelEstado(s.estado).toLowerCase().includes(fc.estado.toLowerCase()));
      return lista;
    },
    solicitudesOrdenadas() {
      if (!this.ordenColumna) return this.solicitudesFiltradas;
      const sorted = [...this.solicitudesFiltradas];
      sorted.sort((a, b) => {
        let vA = a[this.ordenColumna];
        let vB = b[this.ordenColumna];
        if (vA == null) vA = '';
        if (vB == null) vB = '';
        if (typeof vA === 'number' && typeof vB === 'number') return this.ordenDireccion === 'asc' ? vA - vB : vB - vA;
        vA = String(vA).toLowerCase();
        vB = String(vB).toLowerCase();
        if (vA < vB) return this.ordenDireccion === 'asc' ? -1 : 1;
        if (vA > vB) return this.ordenDireccion === 'asc' ? 1 : -1;
        return 0;
      });
      return sorted;
    },
    totalPages() {
      if (this.pageSize >= 999999) return 1;
      return Math.max(1, Math.ceil(this.solicitudesOrdenadas.length / this.pageSize));
    },
    solicitudesPaginadas() {
      if (this.pageSize >= 999999) return this.solicitudesOrdenadas;
      const start = (this.currentPage - 1) * this.pageSize;
      return this.solicitudesOrdenadas.slice(start, start + this.pageSize);
    },
    opcionesKam() {
      return [
        { value: null, text: '— Sin asignar —' },
        ...this.kamsOptions.map(k => ({ value: k.value, text: k.text })),
      ];
    },
  },

  methods: {
    limpiarFiltros() {
      this.filtros = { idTipo: null, estado: null, idUsuarioKam: null, nombre: '', email: '', fechaDesde: '', fechaHasta: '' };
    },

    async cargarKams() {
      try {
        const data = await userService.getKamOptions();
        this.kamsOptions = data || [];
      } catch {
        this.kamsOptions = [];
      }
    },

    async cargarTiposSolicitud() {
      try {
        const data = await diccionarioService.getByTipo('SOL-ECOM');
        this.tiposSolicitud = Array.isArray(data) ? data : [];
      } catch {
        this.tiposSolicitud = [];
      }
    },

    async cargarSolicitudes() {
      this.cargando = true;
      this.error = '';
      try {
        this.solicitudes = await peticionProductoService.getAll();
      } catch (e) {
        this.error = (e && e.response && e.response.data && e.response.data.message) || this.$t('error');
      } finally {
        this.cargando = false;
      }
    },

    // Baja logica: no borra la fila en la base, solo apaga Activo (con quien y cuando en
    // FechaModificacion/IdUsuarioModificacion). Por eso alcanza con sacarla de la lista en
    // pantalla, sin recargar todo desde la API.
    async eliminarSolicitud(s) {
      if (!this.puedeEscribir) return;
      const confirm = await Swal.fire({
        title: this.$t('eliminar_solicitud'),
        text: `${s.nombre} — ${s.email}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('si_eliminar'),
        cancelButtonText: this.$t('cancelar_swal'),
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
      });
      if (!confirm.isConfirmed) return;

      this.eliminandoId = s.id;
      try {
        await peticionProductoService.remove(s.id);
        this.solicitudes = this.solicitudes.filter(x => x.id !== s.id);
      } catch (e) {
        Swal.fire({
          icon: 'error',
          title: this.$t('error_eliminar_solicitud'),
          text: (e && e.response && e.response.data && e.response.data.message) || '',
        });
      } finally {
        this.eliminandoId = null;
      }
    },

    async abrirDetalle(solicitud) {
      this.solicitudSeleccionada = solicitud;
      this.formEdicion.estado = solicitud.estado || 'P';
      this.formEdicion.observacionInterna = solicitud.observacionInterna || '';
      this.formEdicion.idUsuarioKam = solicitud.idUsuarioKam || null;
      this.adjuntos = [];
      this.cotizaciones = [];
      this.modalVisible = true;

      this.cargandoAdjuntos = true;
      try {
        const resp = await archivoAdjuntoService.getArchivosByItem(solicitud.id, 5);
        this.adjuntos = (resp && resp.data) ? resp.data : [];
      } catch {
        this.adjuntos = [];
      } finally {
        this.cargandoAdjuntos = false;
      }

      this.cargandoCotizaciones = true;
      try {
        const resp = await archivoAdjuntoService.getArchivosByItem(solicitud.id, 6);
        this.cotizaciones = (resp && resp.data) ? resp.data : [];
      } catch {
        this.cotizaciones = [];
      } finally {
        this.cargandoCotizaciones = false;
      }
    },

    async guardarCambios() {
      if (!this.puedeEscribir) return;
      // Validation: Asignado requires KAM
      if (this.formEdicion.estado === 'A' && !this.formEdicion.idUsuarioKam) {
        Swal.fire({
          icon: 'warning',
          title: this.$t('kam_requerido'),
          text: this.$t('kam_requerido_msg'),
          confirmButtonColor: '#6172e9',
        });
        return;
      }

      // Build confirmation message
      const estadoAnterior = this.solicitudSeleccionada.estado;
      const estadoNuevo = this.formEdicion.estado;
      let htmlMsg = `<p>${this.$t('seguro_guardar_cambios')}</p>`;

      if (this.formEdicion.idUsuarioKam && this.formEdicion.idUsuarioKam !== (this.solicitudSeleccionada.idUsuarioKam || null)) {
        const kam = this.kamsOptions.find(k => k.value === this.formEdicion.idUsuarioKam);
        const kamNombre = kam ? kam.text : 'el KAM seleccionado';
        htmlMsg += `<p class="text-muted" style="font-size:0.9rem">📧 ${this.$t('notif_kam').replace('{kam}', '<strong>' + kamNombre + '</strong>')}</p>`;
      }
      if (estadoNuevo === 'C' && estadoAnterior !== 'C') {
        if (this.cotizaciones && this.cotizaciones.length > 0) {
          htmlMsg += `<p class="text-muted" style="font-size:0.9rem">📧 ${this.$t('notif_cierre_con_adjunto')}</p>`;
        } else {
          htmlMsg += `<p class="text-warning" style="font-size:0.9rem">⚠️ ${this.$t('notif_cierre_sin_adjunto')}</p>`;
        }
      }

      const confirm = await Swal.fire({
        title: this.$t('confirmar'),
        html: htmlMsg,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('si_guardar'),
        cancelButtonText: this.$t('cancelar_swal'),
        confirmButtonColor: '#6172e9',
        cancelButtonColor: '#6c757d',
      });
      if (!confirm.isConfirmed) return;

      this.guardando = true;
      try {
        const updated = await peticionProductoService.update(this.solicitudSeleccionada.id, {
          estado: this.formEdicion.estado,
          observacionInterna: this.formEdicion.observacionInterna,
          idUsuarioKam: this.formEdicion.idUsuarioKam,
        });
        const idx = this.solicitudes.findIndex(s => s.id === this.solicitudSeleccionada.id);
        if (idx !== -1) {
          this.$set(this.solicitudes, idx, {
            ...this.solicitudes[idx],
            estado: this.formEdicion.estado,
            observacionInterna: this.formEdicion.observacionInterna,
            idUsuarioKam: updated.idUsuarioKam,
            fechaAsignacionKam: updated.fechaAsignacionKam,
            fechaCierre: updated.fechaCierre,
          });
        }
        this.modalVisible = false;
        Swal.fire({ icon: 'success', title: this.$t('guardado'), timer: 1800, showConfirmButton: false });
      } catch (e) {
        this.error = (e && e.response && e.response.data && e.response.data.message) || this.$t('error_guardar');
      } finally {
        this.guardando = false;
      }
    },

    async subirCotizacion(event) {
      if (!this.puedeEscribir) return;
      const files = event.target.files;
      if (!files || files.length === 0) return;
      this.subiendoCotizacion = true;
      try {
        await archivoAdjuntoService.subirArchivos(6, 1, this.solicitudSeleccionada.id, Array.from(files));
        const resp = await archivoAdjuntoService.getArchivosByItem(this.solicitudSeleccionada.id, 6);
        this.cotizaciones = (resp && resp.data) ? resp.data : [];
        event.target.value = '';
      } catch (e) {
        this.error = this.$t('error_subir_cotizacion');
      } finally {
        this.subiendoCotizacion = false;
      }
    },

    async eliminarCotizacion(id) {
      if (!this.puedeEscribir) return;
      const confirm = await Swal.fire({
        title: this.$t('eliminar_cotizacion'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('si_eliminar'),
        cancelButtonText: this.$t('cancelar_swal'),
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
      });
      if (!confirm.isConfirmed) return;
      try {
        await archivoAdjuntoService.eliminarArchivo(id);
        this.cotizaciones = this.cotizaciones.filter(c => c.id !== id);
      } catch {
        this.error = this.$t('error_eliminar_cotizacion');
      }
    },

    ordenarPor(columna) {
      if (this.ordenColumna === columna) {
        this.ordenDireccion = this.ordenDireccion === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumna = columna;
        this.ordenDireccion = 'asc';
      }
      this.currentPage = 1;
    },

    obtenerIconoOrden(columna) {
      if (this.ordenColumna !== columna) return '↕';
      return this.ordenDireccion === 'asc' ? '↑' : '↓';
    },

    iconoOrden(columna) {
      if (this.ordenColumna !== columna) return 'fas fa-sort text-muted';
      return this.ordenDireccion === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },

    scrollTabla(dir) {
      const el = this.$refs.tablaSolicitudes;
      const px = 300;
      if (dir === 'left')   el && el.scrollBy({ left: -px, behavior: 'smooth' });
      if (dir === 'right')  el && el.scrollBy({ left:  px, behavior: 'smooth' });
      if (dir === 'top')    window.scrollTo({ top: 0, behavior: 'smooth' });
      if (dir === 'bottom') window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },

    _onWindowScrollSolicitudes() {
      const cont = this.$refs.tablaSolicitudes;
      if (!cont) return;
      const thead = cont.querySelector('thead.thead-sticky');
      if (!thead) return;
      const top = cont.getBoundingClientRect().top;
      thead.style.transform = top < 0 ? `translateY(${-top}px)` : '';
    },

    formatFecha(fecha) {
      if (!fecha) return '-';
      return new Date(fecha).toLocaleDateString('es-CL');
    },

    nombreKam(idUsuarioKam) {
      if (!idUsuarioKam) return '-';
      const kam = this.kamsOptions.find(k => k.value === idUsuarioKam);
      return kam ? kam.text : '-';
    },

    // El nombre del tipo llega resuelto desde la API (dbo.Diccionarios,
    // Tipo = 'SOL-ECOM', en el idioma de la sesión). Solo se cae al código
    // crudo si la solicitud trae un tipo que el diccionario no tiene.
    labelTipo(solicitud) {
      if (!solicitud) return '-';
      return solicitud.tipoNombre || solicitud.idTipo || '-';
    },

    labelEstado(estado) {
      const map = { P: this.$t('estado_por_asignar'), A: this.$t('estado_asignado'), C: this.$t('estado_cerrado'), E: this.$t('estado_cerrado_sin_exito') };
      return map[estado] || estado;
    },

    badgeClass(estado) {
      const map = {
        P: 'badge badge-pill badge-warning',
        A: 'badge badge-pill badge-info',
        C: 'badge badge-pill badge-success',
      };
      return map[estado] || 'badge badge-pill badge-light';
    },
  },
};
</script>

<style scoped>
.divisor {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  padding: 15px;
  background: #6172e9;
  border-radius: 10px;
}
.form-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #525f7f;
  margin-bottom: 4px;
  display: block;
}
.card {
  border-radius: 10px;
  overflow: hidden;
}

/* ===== Tabla con cabecera inmóvil ===== */
.tabla-scroll-fixed {
  overflow-x: auto;
  position: relative;
  font-size: 0.8rem;
}

.thead-sticky {
  position: relative;
  z-index: 2;
  background: #f8f9fa;
}

.th-ordenable {
  cursor: pointer;
  user-select: none;
  min-width: 90px;
  vertical-align: top;
  white-space: nowrap;
}
.th-ordenable:hover {
  background-color: #e9ecef !important;
}

.th-search-input {
  width: 100%;
  font-size: 11px;
  padding: 2px 4px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  margin-bottom: 3px;
  display: block;
  font-weight: normal;
}

.th-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.tabla-scroll-fixed .table th,
.tabla-scroll-fixed .table td {
  font-size: 12px;
}

/* ===== Botones de scroll ===== */
.btn-scroll-nav {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ced4da;
  background: #f8f9fa;
  color: #495057;
  border-radius: 6px;
}
.btn-scroll-nav:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

/* ===== Barra flotante de paginación ===== */
.pagination-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background: #fff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
}

.detalle-modal {
  padding: 8px 0;
}
.detalle-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.detalle-item:last-child {
  border-bottom: none;
}
.detalle-label {
  font-weight: 600;
  color: #525f7f;
  font-size: 0.85rem;
  flex: 0 0 45%;
}
.detalle-valor {
  color: #32325d;
  font-size: 0.9rem;
  text-align: right;
  flex: 1;
}
.adjunto-item {
  padding: 5px 0;
  border-bottom: 1px solid #f0f0f0;
}
.adjunto-item:last-child {
  border-bottom: none;
}
.adjunto-link {
  font-size: 0.88rem;
  color: #6172e9;
  word-break: break-all;
}
.adjunto-link:hover {
  text-decoration: underline;
}
</style>
